<template>



<div>

    <!-- Header -->
    <div class="header bg-gradient-info py-7  ">
        <b-container>
            <div class="header-body text-center mb-7">
                <b-row class="justify-content-center">
                    <b-col xl="5" lg="6" md="8" class="px-5">
                        <img class="pb-5 logo-img" src="img/brand/green.png">
                        <h1 class="text-dark">Reset Password</h1>
                    </b-col>
                </b-row>
            </div>
        </b-container>
    </div>

    <!-- Page content -->
    <b-container class="mt--8 pb-5">
        <b-row class="justify-content-center">
            <b-col lg="6" md="7">
                <b-card no-body class="bg-color border-5 mb-0">
                    <b-card-body class="px-lg-5 py-lg-5">
                        <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                            <b-row>
                                 <b-col lg="12">
                                    <div class="form-group">
                                        <label class="form-control-label">Enter New Password</label>
                                <!-- <base-input alternative class="mb-3" name="Password" :rules="{required: true, min: 6}" prepend-icon="ni ni-lock-circle-open" type="password" placeholder="Password"> -->
                                <base-input alternative class="mb-3" name="Password"  :rules="{required: true, min: 6}"  prepend-icon="ni ni-lock-circle-open" type="password" placeholder="Password"  v-model="model.password1"></base-input>
                                </base-input>
                                    </div>
                                </b-col>
                                  <b-col lg="12">
                                    <div class="form-group">
                                       <label class="form-control-label">Re-Enter New Password</label>
                                <!-- <base-input alternative class="mb-3" name="Password" :rules="{required: true, min: 6}" prepend-icon="ni ni-lock-circle-open" type="password" placeholder="Password"> -->
                                <base-input alternative class="mb-3" name="Password"  :rules="{required: true, min: 6}" prepend-icon="ni ni-lock-circle-open" type="password" placeholder="Password" v-model="model.password2">
                                </base-input>
                                    </div>
                                </b-col>
                                <b-col lg="12">
                                    <div class="pt-lg-4 mt-lg-2 float-right">
                                        <b-button variant="primary">Reset Password</b-button>
                                        <b-button  to="/home" variant="">Back</b-button>
                                    </div>
                                </b-col>
                            </b-row>
                        </validation-observer>
                    </b-card-body>
                </b-card>

            </b-col>
        </b-row>
    </b-container>

</div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
 
    data() {
    return {
      model: {
        password1: "",
        password2: ""
      },

      methods: {
    ...mapActions("user", ["SetPassword"]),
    onSubmit() {
      const userdata = {
        username: this.$store.state.user,
        password: this.model.password1,
        remember_me: this.model.rememberMe,
      };
      this.setpassword(userdata).then((data) => {
        if (data.data.errors) {
          this.$refs.formValidator.setErrors(data.data.errors);
        }
      });
    },
  },

    };
  }
}
</script>

<style scoped>
.logo-img{
    width: 150px;
    height: auto;
}
.bg-color {
background-color: rgb(241, 241, 241) !important;
}
</style>